import { ref } from "vue";
import { api } from "./apiClient";

export interface AuthUser {
  id: number;
  firstName: string;
  lastName: string;
  displayName: string;
  identifier: string;
  email: string;
  isValidated: boolean;
  createdAt: string;
  updatedAt: string;
}

export const currentUser = ref<AuthUser | null>(null);
export const authenticationLoading = ref(true);

export async function initializeAuthentication() {
  authenticationLoading.value = true;
  try {
    currentUser.value = await api<AuthUser>("/auth/me");
  } catch (_error) {
    currentUser.value = null;
  } finally {
    authenticationLoading.value = false;
  }
}

export async function login(loginValue: string, password: string) {
  const result = await api<{ user: AuthUser }>("/auth/login", {
    method: "POST",
    body: JSON.stringify({ login: loginValue, password }),
  });
  currentUser.value = result.user;
  authenticationLoading.value = false;
  return result.user;
}

export async function logout() {
  try {
    await api<void>("/auth/logout", { method: "POST" });
  } finally {
    currentUser.value = null;
  }
}

export function invalidateAuthentication() {
  currentUser.value = null;
  authenticationLoading.value = false;
}

if (typeof window !== "undefined") {
  window.addEventListener("auth:unauthorized", invalidateAuthentication);
}
